import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from 'lib/src/hooks/usePrevious';
import useForm from '@components/form/hooks/useForm';

import { useHistory } from 'react-router-dom';
import { getTagRouteEndpoint } from '../utils';
import {
    getChallengeTagsIsPosting,
    getChallengeTagsPostError,
    getChallengeTagsPostSuccess,
    getTag,
} from '@selectors/challengeTags';
import { editTag } from '@actions/challengeTags/editTag';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import { RootState } from '@reducers/index';

export default function useEditTag(id: number) {
    const dispatch = useDispatch();
    const history = useHistory();
    const tag = useSelector((state: RootState) => getTag(state, id));
    const endpoint = getTagRouteEndpoint(tag.type);
    const closeModal = useCallback(() => {
        history.push(`/${endpoint}`);
    }, [history, endpoint]);

    const [formState, handleChange] = useForm<FormState>({
        name: tag.name,
        isPublic: tag.isPublic,
        type: tag.type,
    });

    const handleSubmit = useCallback(() => {
        dispatch(editTag(tag.id, formState));
    }, [dispatch, tag, formState]);

    const isPosting = useSelector(getChallengeTagsIsPosting);
    const error = useSelector(getChallengeTagsPostError);
    const postSuccess = useSelector(getChallengeTagsPostSuccess);
    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            closeModal();
        }
    }, [postSuccess, prevPostSuccess, closeModal]);

    return {
        handleSubmit,
        formState,
        handleChange,
        closeModal,
        isPosting,
        error,
    };
}

interface FormState {
    name: string;
    isPublic: boolean;
    type: tagTypes;
}
